export default __webpack_public_path__ + "static/media/Mockup_iphone.1bccdd44.png";